module.exports = __webpack_public_path__ + "img/song.a16e99df.png";